module.exports = __webpack_public_path__ + "static/media/GPSTracking.fd9e65fc.png";